/* ============================================================================
 * DUENDE — variant chip uniform sizer
 *
 * Measures every chip label in each <fieldset class="product__variant-options">,
 * picks the widest natural content width, and exposes it as the CSS variable
 * --chip-size on the fieldset. The shared component-variant-chip.css uses
 * that variable for width AND height so every chip becomes a uniform square
 * (border-radius: 50% turns the square into a perfect circle).
 *
 *   chip size = max(MIN_SIZE_PX, widest natural text width + HORIZONTAL_PADDING_PX)
 *
 * Measurement is taken with the chip-size constraint temporarily released
 * (inline `width: max-content !important` beats the stylesheet !important
 * rule), then restored before applying the final size. This avoids the
 * "measure the constrained box and get the constraint back" trap.
 *
 * Re-runs on:
 *   - initial page load (DOMContentLoaded or sync)
 *   - DOM mutations that add new fieldsets (quick-cart drawer loads via AJAX)
 *   - font load complete (text width changes when Adobe Fonts swaps in)
 *   - window resize (debounced)
 * ============================================================================ */

(function () {
  if (window.__duendeVariantChipSizer) return;
  window.__duendeVariantChipSizer = true;

  var MIN_SIZE_PX = 30;
  var HORIZONTAL_PADDING_PX = 12;

  function sizeFieldset(fieldset) {
    var labels = fieldset.querySelectorAll(
      '.product-option__label:not(.product-option__label--image)'
    );
    if (!labels.length) return;

    var measurable = [];
    labels.forEach(function (label) {
      if (label.querySelector('.product-option__swatch')) return;
      measurable.push(label);
    });
    if (!measurable.length) return;

    var originalStyles = measurable.map(function (label) {
      return label.getAttribute('style') || '';
    });

    measurable.forEach(function (label) {
      label.style.setProperty('width', 'max-content', 'important');
      label.style.setProperty('min-width', '0', 'important');
      label.style.setProperty('max-width', 'none', 'important');
      label.style.setProperty('height', 'auto', 'important');
      label.style.setProperty('min-height', '0', 'important');
      label.style.setProperty('max-height', 'none', 'important');
      label.style.setProperty('padding', '0', 'important');
      label.style.setProperty('border-width', '0', 'important');
    });

    var maxNatural = MIN_SIZE_PX;
    measurable.forEach(function (label) {
      var natural = Math.ceil(
        label.getBoundingClientRect().width + HORIZONTAL_PADDING_PX
      );
      if (natural > maxNatural) maxNatural = natural;
    });

    measurable.forEach(function (label, idx) {
      if (originalStyles[idx]) {
        label.setAttribute('style', originalStyles[idx]);
      } else {
        label.removeAttribute('style');
      }
    });

    fieldset.style.setProperty('--chip-size', maxNatural + 'px');
  }

  function sizeAll(root) {
    (root || document)
      .querySelectorAll('fieldset.product__variant-options')
      .forEach(sizeFieldset);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { sizeAll(); });
  } else {
    sizeAll();
  }

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () { sizeAll(); });
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () { sizeAll(); }, 100);
  });

  var observer = new MutationObserver(function (mutations) {
    var roots = new Set();
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('fieldset.product__variant-options')) {
          roots.add(node.parentNode || document);
        } else if (
          node.querySelector &&
          node.querySelector('fieldset.product__variant-options')
        ) {
          roots.add(node);
        }
      });
    });
    roots.forEach(function (root) { sizeAll(root); });
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
